<template>
  <div class="login-page">
    <!-- 左侧大字 -->
    <div class="left-banner">
      博乐市润景大数据系统
    </div>

    <!-- 登录框 -->
    <div class="login-box">
      <h2>登录</h2>
      <form @submit.prevent="handleLogin">
        <div class="input-group">
          <i class="icon user-icon"></i>
          <input type="text" v-model="username" placeholder="账号：" />
        </div>
        <div class="input-group">
          <i class="icon lock-icon"></i>
          <input type="password" v-model="password" placeholder="密码：" />
        </div>
        <button type="submit">登录</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    handleLogin() {
      if (!this.username || !this.password) {
        alert('请输入账号和密码')
        return
      }

      this.$axios.post('/login', {
        username: this.username,
        password: this.password
      }).then(res => {
        console.log('登录成功:', res)

        const token = res.data.data.token || ''
        if (token) {
          console.log('token::: ', token)
          localStorage.setItem('token', token)
          this.$router.push('/main')
        }
      }).catch(err => {
        console.error('登录失败:', err)
        alert('账号或密码错误')
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  width: 100vw;
  height: 100vh;
  background: url('@/assets/login-bg.jpg') no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden; /* 防止出现滚动条 */
}

/* 左侧大字区域 */
.left-banner {
  flex: 1;
  padding-left: 16%;
  color: white;
  font-size: 60px;
  font-weight: bold;
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6);
}

/* 登录框 */
.login-box {
  width: 360px;
  padding: 40px 30px;
  margin-right: 8%;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.4);
  color: #fff;
}

.login-box h2 {
  text-align: center;
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: bold;
}

.input-group {
  position: relative;
  margin-bottom: 20px;
}

.input-group input {
  width: 100%;
  padding: 10px 10px 10px 35px;
  box-sizing: border-box;
  border: none;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 14px;
  outline: none;
}

.input-group .icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 16px;
  color: #ccc;
}

.user-icon::before {
  content: '👤';
}

.lock-icon::before {
  content: '🔒';
}

button {
  width: 100%;
  padding: 10px;
  background-color: #409EFF;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
}

button:hover {
  background-color: #66b1ff;
}
</style>
